import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

interface QualitativeSectionProps {
  value: any;
  onChange: (value: any) => void;
}

export const QualitativeSection: React.FC<QualitativeSectionProps> = ({ value, onChange }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <motion.div className="glass p-6 mb-4" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 20 }}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between mb-4"
      >
        <h2 className="subsection-title mb-0">Qualitative Assessment</h2>
        <ChevronDown className={`w-5 h-5 transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <>
          <div className="mb-4">
            <label className="form-label">Driver Skill Rating ({value.driver_skill_rating}/5)</label>
            <input
              type="range"
              min="1"
              max="5"
              value={value.driver_skill_rating}
              onChange={(e) => onChange({ ...value, driver_skill_rating: parseInt(e.target.value) })}
              className="w-full"
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Defense Capability Rating ({value.defense_capability_rating}/5)</label>
            <input
              type="range"
              min="1"
              max="5"
              value={value.defense_capability_rating}
              onChange={(e) => onChange({ ...value, defense_capability_rating: parseInt(e.target.value) })}
              className="w-full"
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Reliability Rating ({value.reliability_rating}/5)</label>
            <input
              type="range"
              min="1"
              max="5"
              value={value.reliability_rating}
              onChange={(e) => onChange({ ...value, reliability_rating: parseInt(e.target.value) })}
              className="w-full"
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Strengths</label>
            <textarea
              value={value.strengths}
              onChange={(e) => onChange({ ...value, strengths: e.target.value })}
              placeholder="e.g., Strong fuel scoring, reliable climbing..."
              className="form-input min-h-20"
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Weaknesses</label>
            <textarea
              value={value.weaknesses}
              onChange={(e) => onChange({ ...value, weaknesses: e.target.value })}
              placeholder="e.g., Struggles with defense, slow cycling..."
              className="form-input min-h-20"
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Mechanical Issues</label>
            <textarea
              value={value.mechanical_issues}
              onChange={(e) => onChange({ ...value, mechanical_issues: e.target.value })}
              placeholder="e.g., Shooter misalignment, servo lag..."
              className="form-input min-h-20"
            />
          </div>

          <div>
            <label className="form-label">General Notes</label>
            <textarea
              value={value.notes}
              onChange={(e) => onChange({ ...value, notes: e.target.value })}
              placeholder="Any other observations..."
              className="form-input min-h-20"
            />
          </div>
        </>
      )}
    </motion.div>
  );
};
